import getLanguageByPath from './locale/getLanguageByPath';

const lang = getLanguageByPath();
/**
 * 页面判断为移动端后进行跳转到当前页面的特定内容
 */
function getUserAgent() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return userAgent.toLowerCase();
}

function isiPad() {
  /*  * ipad环境判断更新  * iOS pre 13 以前以ua作判断，13后以platform及maxTouchPoints做判断  */
  return navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

function isiPadPro() {
  return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
}

function isMobile() {
  var userAgent = getUserAgent();
  return (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
      userAgent
    ) || // eslint-disable-next-line
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([ -\/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([ \/])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([- ])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
      userAgent.substr(0, 4)
    )
  );
}

const isHuaweiPad = () => {
  var userAgent = getUserAgent();
  const isAndroid = /android/.test(userAgent);
  const isHuawei = /huawei|huaweipad|matepad/.test(userAgent);
  const isTablet = /(ipad|tablet|huaweipad|matepad)/i.test(userAgent) || (window.innerWidth >= 768 && window.innerHeight >= 1024);

  return isAndroid && isHuawei && isTablet;
};

function replaceUrlPath(oldStr, newStr) {
  // 获取当前完整的URL
  const currentUrl = window.location.href;
  // TODO 测试用
  // const currentUrl = 'https://mechabreak.seasungames.com/m/en/map.html#/';

  // 使用URL对象解析当前URL
  const urlObj = new URL(currentUrl);

  // 对路径部分进行全局替换
  const newPathname = urlObj.pathname.replace(new RegExp(escapeRegExp(oldStr), 'g'), newStr);

  // 构建新URL（保留查询参数和哈希）
  urlObj.pathname = newPathname;
  const newUrl = urlObj.toString();

  // console.log('newUrl', newUrl);

  // 仅在URL实际变化时跳转
  if (newUrl !== currentUrl) {
    window.location.replace(newUrl);
  }
}

// 辅助函数：转义正则特殊字符
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function redirectIfMobile(replaceUrl = IS_MASTER_ENV ? `/${lang}/` : '/zt/', targetUrl = IS_MASTER_ENV ? `/m/${lang}/` : '/m/') {
  if (isMobile() || isiPad() || isHuaweiPad() || isiPadPro()) {
    replaceUrlPath(replaceUrl, targetUrl);
  }
}

function redirectIfPc(replaceUrl = '/m/', targetUrl = IS_MASTER_ENV ? '/' : '/zt/') {
  if (!isMobile() && !isiPad() && !isHuaweiPad() && !isiPadPro()) {
    replaceUrlPath(replaceUrl, targetUrl);
  }
}

const redirect = {
  redirectIfMobile,
  redirectIfPc
};

export default redirect;
